module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.327362a7.ttf";